import { render, staticRenderFns } from "./ProductRelations.vue?vue&type=template&id=0978b2e6&"
import script from "./ProductRelations.vue?vue&type=script&lang=js&"
export * from "./ProductRelations.vue?vue&type=script&lang=js&"
import style0 from "./ProductRelations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports